import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import "./login.css";

const API =
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:10000";

export default function Login() {
  const navigate = useNavigate();

  // State Hooks
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Check if user is already logged in
  const token = localStorage.getItem("token");

  if (token) {
    return <Navigate to="/admin" replace />;
  }

  // Login Function
  const login = async () => {
    if (!email.trim() || !password.trim()) {
      alert("Please enter Email and Password.");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API}/api/auth/login`, {
        email,
        password,
      });

      // Save Login Details
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", res.data.role);

      if (res.data.user) {
        localStorage.setItem(
          "user",
          JSON.stringify(res.data.user)
        );
      }

      // Redirect to Admin Dashboard
      navigate("/admin");
    } catch (err) {
      console.error(err);

      alert(
        err.response?.data?.detail ||
          "Invalid Email or Password"
      );
    } finally {
      setLoading(false);
    }
  };

  // Enter Key Login
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      login();
    }
  };

  // Back to Home
  const backToHome = () => {
    navigate("/");
  };

  return (
    <div className="login-page">


      <div className="login-card">

        <div className="login-badge">
          ADMIN PORTAL
        </div>

        <h1 className="login-title">
          Welcome Back
        </h1>

        <p className="login-subtitle">
          Login to access the IncomeTaxBro Admin Dashboard
        </p>

        <input
          type="email"
          className="login-input"
          placeholder="Enter Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <input
          type="password"
          className="login-input"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <button
          className="login-btn"
          onClick={login}
          disabled={loading}
        >
          {loading ? "Signing In..." : "Login"}
        </button>
        
      <button
        className="back-home-btn"
        onClick={backToHome}
      >
        <ArrowLeft size={18} />
        Back to Home
      </button>
        <div className="login-footer">
          © {new Date().getFullYear()} IncomeTaxBro
        </div>

      </div>

    </div>
  );
}